<template>
  <div class="top-active-container">
    <div class="top-active-row">
      <div class="top-active-card">
        <div class="top-active-header">
          <trophy-outlined class="top-active-icon top-active-icon-purple" />
          <span class="top-active-title">TOP 活跃 SIG（PR）</span>
        </div>
        <div class="top-active-list">
          <div v-for="(item, index) in topSigs.slice(0, 5)" :key="index" class="top-active-item top-active-item-purple">
            <span class="top-active-rank top-active-rank-purple">{{ index + 1 }}</span>
            <span class="top-active-name">{{ item.sigName }}</span>
          </div>
        </div>
      </div>
      <div class="top-active-card">
        <div class="top-active-header">
          <star-outlined class="top-active-icon top-active-icon-blue" />
          <span class="top-active-title">TOP 活跃仓库（PR）</span>
        </div>
        <div class="top-active-list">
          <div v-for="(item, index) in topRepos.slice(0, 5)" :key="index" class="top-active-item top-active-item-blue">
            <span class="top-active-rank top-active-rank-blue">{{ index + 1 }}</span>
            <span class="top-active-name">{{ item.project }}/{{ item.repoName }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import { TrophyOutlined, StarOutlined } from '@ant-design/icons-vue';

const topSigs = ref([]);
const topRepos = ref([]);

const fetchData = async () => {
  try {
    const [sigsRes, reposRes] = await Promise.all([
      axios.get('/metric/pr/topSigs', { params: { time: 1 } }),
      axios.get('/metric/pr/topRepos', { params: { time: 1 } })
    ]);
    if (sigsRes.data?.code === 200) topSigs.value = sigsRes.data.data;
    if (reposRes.data?.code === 200) topRepos.value = reposRes.data.data;
  } catch (error) {
    console.error('PR TOP活跃数据加载失败:', error);
  }
};

onMounted(() => {
  fetchData();
});
</script>

<style scoped>
.top-active-container { background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; padding: 20px 24px; }
.top-active-row { display: flex; gap: 16px; }
.top-active-card { flex: 1; }
.top-active-header { display: flex; align-items: center; gap: 8px; margin-bottom: 16px; }
.top-active-icon { font-size: 18px; }
.top-active-icon-purple { color: #9810fa; }
.top-active-icon-blue { color: #3b82f6; }
.top-active-title { font-size: 16px; font-weight: 600; color: #1a1a2e; }
.top-active-list { display: flex; flex-direction: column; gap: 8px; }
.top-active-item { display: flex; align-items: center; gap: 10px; padding: 10px 14px; border-radius: 8px; }
.top-active-item-purple { background: #faf5ff; }
.top-active-item-blue { background: #eff6ff; }
.top-active-rank { display: inline-flex; align-items: center; justify-content: center; width: 24px; height: 24px; border-radius: 50%; font-size: 12px; font-weight: 700; color: #fff; flex-shrink: 0; }
.top-active-rank-purple { background: #9810fa; }
.top-active-rank-blue { background: #3b82f6; }
.top-active-name { font-size: 14px; font-weight: 500; color: #374151; }
</style>
